<template>
  <div>
    <div v-if="normal" class="filter">
      <div class="filter-caption">
        <div class="school">学校</div>
        <div :class="{'filter-item':true, 'filter-item-active':classRoom.school===null}"
             @click="filterHandler('all')">全部
        </div>
      </div>
      <div class="filter-content">
        <div v-for="item in school" :class="{'filter-item':true, 'filter-item-active':classRoom.school===item}"
             @click="filterHandler(item)">{{ item }}
        </div>
      </div>
    </div>
    <el-form class="el-form-m20" :inline="true" size="small" :model="classRoom">
      <el-form-item class="search-bar">
        <el-input :class="{'w-30vw':normal,'w-classroom-100per':!normal}" v-model="classRoom.crName"
                  placeholder="请输入班级名称">
          <el-button class="btn-search" @click="search" icon="el-icon-search" slot="append"></el-button>
        </el-input>
      </el-form-item>

      <el-form-item v-if="normal">
        <el-button-group>
          <el-button v-if="perm.indexOf('classroom:allot') > -1" type="primary" icon="el-icon-set-up"
                     @click="dialogCourseVisible=true">分配课程
          </el-button>
          <el-button v-if="perm.indexOf('classroom:insert') > -1" type="primary"
                     icon="el-icon-circle-plus-outline"
                     @click="createRow">新建班级
          </el-button>
          <el-button v-if="perm.indexOf('classroom:delete') > -1" type="danger" icon="el-icon-delete"
                     @click="deleteSlt">批量删除
          </el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table
        ref="classRoomTable"
        :data="list"
        tooltip-effect="dark"
        style="width: 100%"
        row-key="id"
        :row-class-name="setClassName"
        @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45" :reserve-selection="true">
      </el-table-column>
      <el-table-column v-if="normal" type="expand" width="30">
        <template slot-scope="props">
          <el-tag style="margin: 0" type="info">正在学习的课程</el-tag>
          <span> - </span>
          <el-tag :class="{'el-tag-first':i===0}" v-for="(item,i) in props.row.courseMini"
                  :closable="normal && perm.indexOf('classroom:delete') > -1"
                  :key="i"
                  @close="removeCourseFromClassRoom(props.row, item)">{{ Object.values(item)[0] }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="编号" width="80">
      </el-table-column>
      <el-table-column prop="crName" label="班级名称" width="180">
      </el-table-column>
      <el-table-column prop="school" label="学校">
      </el-table-column>
      <el-table-column prop="college" label="学院">
      </el-table-column>
      <!--<el-table-column prop="assistant" label="助教">
      </el-table-column>-->
      <el-table-column v-if="normal" label="操作">
        <template slot-scope="scope">
          <el-link v-if="perm.indexOf('classroom:update') > -1"
                   type="primary"
                   icon="el-icon-edit"
                   @click="modifyRow(scope.$index, scope.row)">修改
          </el-link>
          <el-link v-if="scope.row.hasStudents"
                   type="primary"
                   icon="el-icon-view"
                   @click="showDetails(scope.$index, scope.row)">查看学生
          </el-link>
          <el-dropdown
              v-if="perm.indexOf('classroom:export') > -1 || (!scope.row.complete && perm.indexOf('classroom:over') > -1)">
            <el-link type="primary" icon="el-icon-more">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-link>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-link :underline="false" v-if="perm.indexOf('classroom:export') > -1"
                         type="warning"
                         icon="el-icon-files"
                         @click="exportLearn(scope.$index, scope.row)">导出学习记录
                </el-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-link :underline="false"
                         v-if="!scope.row.complete && perm.indexOf('classroom:over') > -1"
                         type="danger"
                         icon="el-icon-folder-checked"
                         @click="endLearn(scope.$index, scope.row)">结束培训
                </el-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        :layout="normal ? 'sizes, prev, pager, next' : 'prev, pager, next'"
        :page-size="size"
        :total="total"
        :current-page.sync="index"
        @size-change="sizeChange"
        @current-change="currentChange">
    </el-pagination>
    <el-dialog v-if="normal && (perm.indexOf('classroom:insert') > -1 || perm.indexOf('classroom:update') > -1)"
               @close="cancelForm" :title="title" width="40%" :visible.sync="dialogFormVisible"
               :lockScroll="false">
      <el-form ref="classRoomForm" :show-message="false" :model="form" label-position="right" label-width="80px">
        <el-form-item prop="crName" label="班级名" :required="true">
          <el-input v-model="form.crName" placeholder="请输入班级名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="school" label="学校" :required="true">
          <el-autocomplete
              style="width:100%"
              v-model="form.school"
              :fetch-suggestions="querySearch"
              placeholder="请输入或选择学校"
          ></el-autocomplete>
          <!--<el-input v-model="form.school" placeholder="请输入学校"
                    autocomplete="off"></el-input>-->
        </el-form-item>
        <el-form-item prop="college" label="学院" :required="true">
          <el-input v-model="form.college" placeholder="请输入学院"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="confirmForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="normal && perm.indexOf('classroom:allot') > -1" :visible.sync="dialogCourseVisible" @close="cs"
               @opened="$refs['course'].getList()">
      <course ref="course" :normal="false" @rowSelected="rowSelection"></course>
      <div slot="footer" class="dialog-footer">
        <el-button-group>
          <el-button size="small" @click="dialogCourseVisible=false">取 消</el-button>
          <el-button size="small" icon="el-icon-s-fold" @click="appendCourse">追加课程</el-button>
          <el-button size="small" icon="el-icon-setting" @click="resetCourse">重新分配课程
          </el-button>
        </el-button-group>
      </div>
    </el-dialog>
    <el-dialog :title="`该班学生共有${curStudentList.length}人`" v-if="normal" :visible.sync="dialogDetailsVisible"
               @close="curVideoList=[]">
      <el-tag style="margin-bottom: 5px" v-for="item in curStudentList"
              :closable="perm.indexOf('classroom:delete') > -1"
              @close="removeStuFormClassRoom(item.openId)" :key="item.id">
        {{ item.name }} -
        <template v-if="perm.indexOf('ma:privacy') > -1">{{ item.mobile }}</template>
        <template v-else>{{ item.mobile.replace(item.mobile.substr(3, 4), '****') }}</template>
      </el-tag>
    </el-dialog>
  </div>
</template>

<script>
import Course from "./Course";
import helper from "../common/CZHelper";
import CZHelper from "@/common/CZHelper";

export default {
  name: "ClassRoom",
  components: {
    Course
  },
  props: {
    normal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL + "ma/classroom/",
      title: '',
      dialogFormVisible: false,
      dialogCourseVisible: false,
      dialogDetailsVisible: false,
      courseList: [],
      multipleSelection: [],
      classRoomId: 0,
      classRoom: {
        school: null,
        crName: null
      },
      form: {
        school: null,
        crName: null,
        college: null
      },
      list: [],
      total: 0,
      size: this.normal ? 10 : 6,
      index: 1,
      school: [],
      perm: localStorage.getItem('perm').split(","),
      curStudentList: []
    }
  },
  created() {
    /*this.getSchool();
    this.getList();*/
  },
  beforeRouteEnter(to, from, next) {
    //获取不了this，会携带请求头
    next(self => {
      self.getSchool();
      self.getList();
    });
  },
  methods: {
    //从该班移除指定课程
    removeCourseFromClassRoom(row, courseItem) {
      this.$axios.get(this.apiUrl + "removeCourse",
          {
            params: {crId: row.id, courseId: Object.keys(courseItem)[0]}
          })
          .then(({data}) => {
            if (data.code === 200) {
              row.courseMini = row.courseMini.filter((v) => Object.keys(v)[0] !== Object.keys(courseItem)[0]);
              if (row.courseMini.length <= 0) {
                this.$refs['classRoomTable'].toggleRowExpansion(row, false);
                this.getList();
              }
            }
          });
    },
    //从该班移除指定学生
    removeStuFormClassRoom(openId) {
      this.$axios.get(this.apiUrl + "removeStu",
          {
            params: {crId: this.classRoomId, openId: openId}
          })
          .then(({data}) => {
            if (data.code === 200) {
              this.curStudentList = this.curStudentList.filter((v) => v.openId !== openId);
              if (this.curStudentList.length <= 0) {
                this.dialogDetailsVisible = false;
                this.getList();
              }
            }
          });
    },
    showDetails(index, row) {
      this.dialogDetailsVisible = true;
      this.classRoomId = row.id;
      this.$axios.get(
          this.apiUrl + "details?crId=" + row.id
      ).then(({data}) => {
        this.curStudentList = JSON.parse(data.message);
      });
    },
    endLearn(index, row) {
      this.$confirm('结束培训会终止本班学生线上学习, 是否继续?', '提示', {
        confirmButtonText: '继续',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        this.$axios.get(this.apiUrl + "endLearn?crId=" + row.id)
            .then(({data}) => {
              if (data.code === 200) {
                this.$message.success('培训已结束，可以导出该学习记录了');
                this.getList();
              } else {
                this.$message.error('归档失败，请稍后再试');
              }
            });
      }).catch(() => {
        //    点击取消按钮的操作，没有会报错
      });
    },
    exportLearn(index, row) {
      this.$axios(
          {
            url: this.apiUrl + "exportExcel?cid=" + row.id,
            method: 'post',
            responseType: 'arraybuffer'
          })
          .then((resp) => {
            let fileName = row.crName + ".xlsx";
            CZHelper.ajaxDownload(resp, fileName);
          });
    },
    setClassName({row, index}) {
      // 通过自己的逻辑返回一个class或者空
      return !row.courseMini ? 'expand' : '';
    },
    // 自己调动的清除选择
    cs() {
      this.courseList = [];
      if (this.$refs['course']) this.$refs['course'].cs();
      this.$refs['classRoomTable'].clearSelection();
    },
    // 外部调用清楚选择
    cleanSeletedRows() {
      this.$refs['classRoomTable'].clearSelection();
    },
    sizeChange(val) {
      this.size = val;
      this.getList();
    },
    currentChange(val) {
      this.index = val;
      this.getList();
    },
    querySearch(queryString, cb) {
      // 只能用{value:***}的对象数组才能看到结果，简单数组看不到结果
      let school = this.school.map((v, i) => {
        return {value: v}
      });
      let results = queryString ? school.filter(
          (item) => {
            return (item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
      ) : school;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    // table控件数据选中回调
    handleSelectionChange(val) {
      if (!this.normal) this.$emit("rowSelected", val);
      this.multipleSelection = val;
    },
    filterHandler(v) {
      if (v === 'all')
        this.classRoom.school = null;
      else
        this.classRoom.school = v;
      this.index = 1;
      this.getList();
    },
    rowSelection(rows) {
      if (!rows.length) return;
      this.courseList = rows;
    },
    deleteSlt() {
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        if (this.multipleSelection.length <= 0) return;
        let ids = [];
        this.multipleSelection.map((v, i) => ids.push(v.id));
        this.$axios.post(
            this.apiUrl + "remove",
            {
              ids: ids.join(",")
            }
        ).then(response => {
          if (response.data.code === 200) {
            this.getList();
            this.getSchool();
            this.cs();
          }
        });
      }).catch(() => {
        //    点击取消按钮的操作，没有会报错
      });
    },
    createRow() {
      this.index = 1;
      this.show('添加班级');
    },
    modifyRow(rowIndex, row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.show('修改班级');
    },
    show(title) {
      this.dialogFormVisible = true;
      this.title = title;
      if (this.$refs['classRoomForm']) this.$refs['classRoomForm'].clearValidate();
    },
    cancelForm() {
      this.dialogFormVisible = false;
      this.form = {name: null, videoId: null, college: null};
    },
    confirmForm() {
      this.$refs['classRoomForm'].validate((valid) => {
        if (valid) {
          let postUrl = this.form.id ? 'modify' : 'add';
          postUrl = this.apiUrl + postUrl;
          this.$axios.post(postUrl, this.form).then(response => {
            if (response.data.code === 200) {
              this.$message.success('操作成功');
              this.getList();
            } else {
              this.$message.error('操作失败');
            }
            this.cancelForm();
            this.getSchool();
          });
        } else {
          return false;
        }
      });
    },
    getSchool() {
      this.$axios.post(
          this.apiUrl + 'school'
      ).then(response => {
        this.school = response.data;
      });
    },
    // 追加课程
    appendCourse() {
      this.allotCourse("append");
      // console.log("classroomIds=" + classRoomIds + " courseIds=" + courseIds)

    },
    resetCourse() {
      this.allotCourse("reset");
    },
    allotCourse(target) {
      if (this.multipleSelection.length <= 0) {
        this.$message.warning('请选择班级');
        return;
      }
      if (this.courseList.length <= 0) {
        this.$message.warning('请选择课程');
        return;
      }
      let classRoomIds = this.multipleSelection.map(item => item.id);
      let courseIds = this.courseList.map(item => item.id);
      this.$axios.post(
          this.apiUrl + target,
          {
            cIds: courseIds.join(","),
            crIds: classRoomIds.join(",")
          }
      ).then(response => {
        if (response.data.code === 200) {
          this.$message.success('分配课程成功');
          this.cs();
          this.getList();
        } else {
          this.$message.error('分配课程失败');
        }
        this.dialogCourseVisible = false;
      });
    },
    search() {
      this.index = 1;
      this.getList();
    },
    getList() {
      let params = {
        index: this.index,
        size: this.size,
        cr: JSON.stringify(this.classRoom),
        normal: this.normal
      };
      helper.getList(this.apiUrl + 'list', params, this);
    }
  }
}
</script>

<style scoped>
@import "../css/common.css";

.el-tag {
  margin: 0 5px 5px;
}

.el-tag-first {
  margin-left: 0;
}

.el-table th, .el-table td {
  padding: 5px 0;
}

.el-link {
  margin: 0 5px;
}

.el-form-m20 {
  margin: 0 10px;
  /*text-align: right;*/
}

.school {
  color: #9f9f9f;
  width: 78px;
}

.filter {
  display: flex;
  color: #e79b37;
  padding: 10px 0 10px 25px;
  font-size: 0.9em;
  background: white;
  border-radius: 4px;
  margin-bottom: 20px;
}

.filter-content {
  display: flex;
  flex-wrap: wrap;
}

.filter-caption {
  display: flex;
  min-width: 130px;
}

.filter-item-active {
  color: #8b0000;
}

.filter-item {
  margin: 0 10px;
  cursor: pointer;
}

</style>